@if (cloneFinalised$ | async) {
  <eco-job-status-placeholder title="Tenant Configuration & Data Successfully Exported!"
    subtitle="Configuration & data for {{ (cloneFromTenant$ | async)?.Value }} was successfully cloned from Tenant.">
    <div class="steps-container">
      <div class="step">
        <div>
          <div class="step-number">1</div>
        </div>
        <div class="step-content">
          <h1>Clone Export Id</h1>
          <p>Copy this <b>Export Id</b> and do not change or refresh the page until you haven't stored this unique identifier.
        Otherwise you won't be able to find your exported configuration & data and you will have to start the process all over again.</p>
        <div class="copy-container">
          <div>Export Id:</div>
          <input #exportIdInput
            (click)="selectText()"
            [value]="cloneJobId$ | async"
            class="copy-input">
            <button (click)="copyText()" mat-raised-button color="accent">{{ copyButtonText }} <mat-icon>content_copy</mat-icon></button>
          </div>
        </div>
      </div>
      <div class="step">
        <div>
          <div class="step-number">2</div>
        </div>
        <div class="step-content">
          <h1>Arrange Configuration movement</h1>
          <p>Ask your manager how to make a request for moving your exported Configuration & Data to the desired environment
            where your target tenant is placed. Make sure to include the <b>Export Id</b> from above in the email.</p>
          </div>
        </div>
        <div class="step">
          <div>
            <div class="step-number">3</div>
          </div>
          <div class="step-content">
            <h1>Import Configuration & Data</h1>
            <p>After CloudOps have moved the exported data in the final environment you will get an <b>Import Id</b>.
            Go to <b>Clone</b> page, select <b>Import Only</b> option from the top and paste the Import Id in there
            in order to finish the Clone process.
          </p>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button mat-raised-button color="accent" (click)="cloneAnotherTenant()">
        Clone another tenant
      </button>
    </div>
  </eco-job-status-placeholder>
} @else {
  <form #cloneForm="ngForm">
    <div class="row selectors-container">
      <div class="tenant">
        <div>
          <span class="title">Clone From:</span>
          <mat-select name="cloneFromTenant" placeholder="Select source tenant" class="mat-primary"
            [(ngModel)]="cloneFromTenantValue" (selectionChange)="changeCloneFrom()">
          @for (tenant of getTenantList(); track tenant) {
            <mat-option [value]="tenant.Value">
              {{ tenant.Value }}
            </mat-option>
          }
        </mat-select>
      </div>
      <div class="environment">
        <span class="title">Environment:</span>
        {{ (cloneFromEnvironment$ | async)?.EnvironmentName }}
      </div>
      <div class="clone-records">
        <mat-checkbox name="CloneRecords" [(ngModel)]="cloneRecords">
          Clone module records (for large tenants, this can take a very long time)
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div class="row">
    <button mat-raised-button [disabled]="!isCloneAvailable()" class="mat-accent" type="submit"
      (click)="openCloneConfirmationPopup()">
      Clone Export Only
    </button>
  </div>
</form>
}

